export const formatAge=(value)=>{
  return value < 0 || typeof (value) == 'undefined' || value == "" ? '' : value + "岁";
}

export const formatWeight=(value)=>{
  return value == null ? '---' : value + 'kg';
}
export const formatHeight=(value)=>{
  return value == null ? '---' : value + 'cm';
}
export const formatVal=(value)=>{
  return value == null ? '---' : value;
}
export const formatGy=(value)=>{
  let arr = ['正常', '缺失1/3', '1/3<缺失<2/3', '缺失>2/3'];
  value = value == null ? '---' : arr[value];
  return value;
}
export const formatFixed2=(value)=>{
  if (value == '0') value = '0.00'
  value = (value == null || value == 'null' || value == '') ? '---' : (value > 0 ? '+' + parseFloat(value).toFixed(2) : parseFloat(value).toFixed(2));
  return value;
}
export const  formatDate=(value)=>{
  return value != null && value.length > 10 ? value.substring(0, 10) : value;
}
export const formatShili=(value)=>{
  let temp = value;
  temp = '5.10'
  if (value != null && value != 'null' && value != '') {
    value += " ";
    temp = value.substring(value.indexOf(".") + 1);
    temp = temp.replace(" ", '');
    if (temp.length > 2) {
      temp = parseFloat(value).toFixed(2);
    } else {
      if (temp.length < 2) {
        temp = parseFloat(value).toFixed(1);
      } else {
        temp = value;
      }
    }
  } else {
    temp = '---'
  }
  if (temp) {
    let tempArr = temp.split('.');
    if (tempArr[1].indexOf('0') == 1) {
      tempArr[1] = tempArr[1].replace(0, '')
    }
    temp = tempArr[0] + '.' + tempArr[1]
  }
  return temp.replace('.00', '.0');
}